import React from 'react';
import './UnifiedLoader.scss';

interface UnifiedLoaderProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  variant?: 'default' | 'minimal';
  className?: string;
}

export const UnifiedLoader: React.FC<UnifiedLoaderProps> = ({
  text = '',
  size = 'md',
  fullScreen = false,
  variant = 'default',
  className = ''
}) => {
  const sizeConfig = {
    sm: '40px',
    md: '56px',
    lg: '72px'
  };

  const spinnerSize = sizeConfig[size];
  const containerClass = `unified-loader ${fullScreen ? 'unified-loader--fullscreen' : 'unified-loader--inline'} ${variant === 'minimal' ? 'unified-loader--minimal' : ''} ${className}`.trim();

  return (
    <div className={containerClass}>
      <div className="unified-loader__content">
        <div className="unified-loader__spinner-wrapper">
          <div
            className="unified-loader__spinner"
            style={{ width: spinnerSize, height: spinnerSize }}
          >
            <div className="unified-loader__circle"></div>
            <div className="unified-loader__circle-glow"></div>
          </div>
        </div>
        {text && (
          <p className="unified-loader__text">{text}</p>
        )}
      </div>
    </div>
  );
};
